import { EcommercePayment, OrderAddress } from "../requests/OrderRequests";

export const ACCEPT_SCRIPT_ID = "acceptScript";

export interface AcceptAuthData {
    clientKey: string;
    apiLoginID: string;
}

export interface AcceptCardData {
    cardNumber: string;
    month: string;
    year: string;
    cardCode: string;
    zip: string;
    fullName: string;
}

export interface AcceptSecureData {
    authData: AcceptAuthData;
    cardData: AcceptCardData;
}

export const LoadAcceptScript = (
    scriptSrc: string,
    onLoad: () => void,
    onLoadError: (prompt: string | false) => void,
) => {
    const existingScript = document.getElementById(ACCEPT_SCRIPT_ID);

    if (!existingScript) {
        const script = document.createElement("script");
        script.src = scriptSrc;
        script.id = ACCEPT_SCRIPT_ID;
        script.type = "text/javascript";
        script.charset = "utf-8";
        document.body.appendChild(script);
        script.onload = onLoad;
        script.onerror = (e: any) => {
            onLoadError(false);
        };
    } else {
        onLoad();
    }
};

export const AcceptValidatePayment = (
    clientKey: string,
    loginId: string,
    orderAddress: OrderAddress,
    ecommercePayment: EcommercePayment,
): Promise<any> => {
    return new Promise((resolve, reject) => {
        if (
            !(
                ecommercePayment.cardNum &&
                ecommercePayment.expiryMonth &&
                ecommercePayment.expiryYear &&
                ecommercePayment.cvv &&
                ecommercePayment.nameOnCard
            )
        ) {
            return reject("All card fields must be filled out.");
        }
        const secureData: AcceptSecureData = {
            authData: {
                clientKey: clientKey,
                apiLoginID: loginId,
            },
            cardData: {
                cardNumber: ecommercePayment.cardNum,
                month: ecommercePayment.expiryMonth,
                year: ecommercePayment.expiryYear,
                cardCode: ecommercePayment.cvv,
                zip: orderAddress.postal,
                fullName: ecommercePayment.nameOnCard,
            },
        };
        (window as any).Accept.dispatchData(secureData, (data: any) =>
            resolve(data),
        );
    });
};
